/**
 * Maps server-generated CSS class name strings (from CssClassNames.cs)
 * to Tailwind utility classes for use in the GRC grid.
 *
 * The API embeds class name strings in the response (e.g. DayDetailDto.TotalBlockedCountCss).
 * This utility converts them so the React UI never applies arbitrary class strings.
 */

const CSS_MAP: Record<string, string> = {
  // Room capacity exceeded → red; within limits → black
  "grc-total-blocked-count_red": "text-red-600 font-semibold",
  "grc-total-blocked-count_black": "text-slate-900 font-semibold",

  // Available-to-sell: negative → red; zero or positive → gray
  "grc-availabletosell_red": "text-red-600",
  "grc-availabletosell_gray": "text-slate-400",

  // SoftHold cell states
  "grc-softhold-unchecked": "opacity-30",
  "grc-softhold-preferreddates": "bg-blue-100",
  "grc-softhold-overbooking": "bg-red-100",

  // Column/cell background – holidays & Deloitte days
  "bg-deloitte-day": "bg-emerald-50",
  "bg-deloitte-day-header": "bg-emerald-100",
  "bg-US-holiday": "bg-amber-50",
  "bg-US-holiday-header": "bg-amber-100",
  "bg-default-header": "bg-slate-100",

  // Event status indicator dot colours
  "event-status-definite": "bg-green-600",
  "event-status-tentative": "bg-yellow-400",
  "event-status-prospect": "bg-sky-400",
  "event-status-softhold": "bg-purple-500",
  "event-status-draft": "bg-slate-500",
  "event-status-draft-Core": "bg-slate-700",
  "event-status-draft-Secondary": "bg-slate-400",
};

/** Converts a server-sent CSS class string to Tailwind classes. Falls back gracefully. */
export function grcCss(serverClass: string | null | undefined): string {
  if (!serverClass) return "";
  return CSS_MAP[serverClass] ?? "";
}
